<script>
  import { createEventDispatcher } from 'svelte'
  import { fly }                   from 'svelte/transition'

  export let lesson

  const dispatch = createEventDispatcher()

  const play = recording => {
    dispatch('play', recording)
  }
</script>

<style lang="scss">
  p.description {
    font-size: 0.9rem;
    line-height: 1.3em;
    font-weight: 100;
    display: block;
    font-style: italic;
    margin-bottom: 2 * $GU;

    &:first-letter {
      font-size: 1.5em;
      padding-right: 0.1em;
      float: left;
    }
  }

  table {
    width: calc(100% + #{2 * $GU});
    margin: 0 #{-$GU};

    tr {
      border-radius: 3px;
      transition: all 0.15s ease-in-out;

      td {
        padding: $GU;
        border-radius: 3px;

        &:last-of-type {
          text-align: right;
          transition: inherit;
          a {
            color: $x-light-grey;

            &:last-of-type {
              margin-left: 2 * $GU;
            }
          }
        }
      }

      &:hover {
        background-color: $dark;
        box-shadow: 0 0 #{$GU / 2} $black;

        td:last-of-type {
          a {
            color: $pink;
          }
        }
      }
    }
  }
</style>

<p class="description">
  {lesson.description}
</p>
<table in:fly={{ y: 200, delay: 300, duration: 300 }} out:fly={{ y: 200, duration: 300 }}>
  {#each lesson.recordings as recording}
    <tr>
      <td>{recording.title}</td>
      <td>
        <a on:click|preventDefault={() => play(recording)} href="#/">play</a>
        <a href={'https://gateway.pinata.cloud/ipfs/' + recording.hash} target="_blank" download>download</a>
      </td>
    </tr>
  {/each}
</table>
